import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

export default function StopScreenSharePopup({ open, handleClose }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Screen Sharing Stopped</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Screen sharing is required to carry out this Mission
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Share Screen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
